export default __webpack_public_path__ + "static/media/7.6eba15e9.png";